document.querySelectorAll('.collaborations').forEach((collab) => {
  const track = collab.querySelector('.collaborations__track');
  const items = Array.from(collab.querySelectorAll('.collaborations__item'));
  const prevButton = collab.querySelector('.collaborations__arrow--prev');
  const nextButton = collab.querySelector('.collaborations__arrow--next');

  const videos = Array.from(collab.querySelectorAll('video.collaborations__media'));
  if (videos.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { root: track, threshold: 0.6 }
    );
    videos.forEach((video) => observer.observe(video));
  }

  if (!track || items.length < 2) return;

  function scrollToNextItem(direction) {
    const currentScroll = track.scrollLeft;
    let target = items[items.length - 1];

    for (const item of items) {
      const offset = item.offsetLeft;
      if (direction > 0 && offset > currentScroll + 10) {
        target = item;
        break;
      }
      if (direction < 0 && offset < currentScroll - 10) {
        target = item;
      }
    }
    track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
  }

  prevButton?.addEventListener('click', () => scrollToNextItem(-1));
  nextButton?.addEventListener('click', () => scrollToNextItem(1));
});
